import type { ProductImageEntry } from "./types";
const rows = [
  [
    "operations.published-workday",
    "Publicerad arbetsdag",
    "Published working day",
    "Den publicerade kalendern och ingången till bemanningsluckor.",
    "The published calendar and the entry to staffing gaps.",
  ],
  [
    "operations.replacement-proposal",
    "Förslag på ersättare",
    "Replacement proposal",
    "Ett sparat ersättarförslag visar vem som kan täcka berörda besök innan planeraren fattar beslut.",
    "A saved replacement proposal shows who can cover affected visits before the planner decides.",
  ],
  [
    "operations.staffing-settings",
    "Regler för bemanning",
    "Staffing settings",
    "Inställningar för kontakt, förslag och godkännande inom enhetens bemanningsflöde.",
    "Settings for contact, proposals and approval within the unit's staffing workflow.",
  ],
] as const;
export const OPERATIONS_CATALOGUE: readonly ProductImageEntry[] = rows.map(
  ([id, sv, en, showsSv, showsEn]) => ({
    id,
    module: "Drift och bemanning",
    area: "operations",
    opens: "Drift → publicerad dag → Bemanningsluckor",
    scenario: "S3",
    setup: [
      "Publicera ett verkligt sparat DEV-resultat",
      "Rapportera en syntetisk sjukdag genom den vanliga API-mutationen",
      "Öppna rätt arbetsdag och invänta sparat förslag",
    ],
    visual: { variant: 0 },
    text: {
      sv: {
        alt: sv,
        shows: showsSv,
        proves:
          "Vyn visar det publicerade resultatet och verksamhetens egna bemanningsregler. Ett förslag är skilt från planerarnas godkännande.",
      },
      en: {
        alt: en,
        shows: showsEn,
        proves:
          "The view shows the published result and the organisation's staffing rules. A proposal remains separate from planner approval.",
      },
    },
    use: ["pages/Plattform.tsx", "pages/Features/Scheduling.tsx"],
  }),
);
